const taskManagementSystem = [
    {
      icon: "map",
      key: "taskManager",
      name: "Task Management",
      url: "home/app/taskManager",
      description: "Efficient Task Handling",
      disabled: false,
      productionReady : true
    },
    {
      icon: "AccountCircle",
      key: "userTask",
      name: "User Control Task",
      url: "home/app/taskManager",
      description: "User View Task Details, and update their status",
      disabled: true,
      productionReady : true
    },
    {
      icon: "person",
      key: "taskType",
      name: "Task Type",
      url: "home/app/taskManager",
      description: "Task Type details",
      disabled: false,
      productionReady : true
      },
      {
      icon: "candlestick_chart",
      key: "taskPriority",
      name: "Task Priority",
      url: "home/app/taskManager",
      description: "Task Priority details",
      disabled: false,
      productionReady : true
      },
      {
      icon: "person_pin_icon",
      key: "taskStatus",
      name: "Task Status",
      url: "home/app/taskManager",
      description: "Task Status details",
      disabled: false,
      productionReady : true
      },
      {
        icon: "assignment",
        key: "sla",
        name: "SLA Reports",
        url: "home/app/sla-report",
        description: "",
        disabled: false,
        productionReady : true
      },
      {
        icon: "map",
        key: "taskDetails",
        name: "Task Management",
        url: "home/app/taskManager",
        description: "Efficient Task Handling",
        disabled: true,
        productionReady : true
      },
      {
        icon: "map",
        key: "taskManagerOnCalender",
        name: "Task Management",
        url: "home/app/taskManager",
        description: "",
        disabled: true,
        productionReady : true
      }, 
  ];
  
  export { taskManagementSystem };
  